import React from "react"
import { Helmet } from "react-helmet"
import { StaticImage } from "gatsby-plugin-image"
import { navigate } from "gatsby"
import ContentPageLayout from "../../components/ContentPageLayout"
import CommunityContentLayout from "../../components/CommunityContentLayout"
import SCButton from "../../components/buttons/SCButton"
import { FaFacebook, FaWhatsapp, FaInstagram } from "react-icons/fa"
import firebase from "firebase"
import { firebaseInit } from "../../config"
import config from "../../config"

const InsigniasPage = ({ location }) => {
  const [formValues, setFormValues] = React.useState({
    id: "",
    nombre: "",
    avatar: "",
  })
  const [isPremium, setIsPremium] = React.useState(false)
  const [category, setCategory] = React.useState("")
  const [userToken, setUserToken] = React.useState("")
  const [insignias, setInsignias] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState("")
  const [showModal, setShowModal] = React.useState(false)
  const [selectedBadge, setSelectedBadge] = React.useState(null)

  React.useEffect(() => {
    firebaseInit(firebase)
    const unregister = firebase.auth().onAuthStateChanged(async user => {
      if (!user) return navigate("/")
      const token = await user.getIdToken(true)
      setUserToken(token)
      fetch(`${config.serverUri}/users?email=${user.email}`, {
        headers: { "x-sc-signature": token },
      })
        .then(r => (r.ok ? r.json() : Promise.reject(r.status)))
        .then(([acct]) => {
          setFormValues({
            id: acct.id,
            nombre: acct.nombre,
            avatar: acct.avatar?.startsWith("http")
              ? acct.avatar
              : acct.avatar
              ? `${config.serverUri}${acct.avatar}`
              : "",
          })
          setIsPremium(acct.suscription === "premium")
          setCategory(
            acct.predominantCategory === "ninguna"
              ? "Usuario Shift"
              : acct.predominantCategory
          )
        })
        .catch(() => navigate("/"))
    })
    return () => unregister()
  }, [])

  React.useEffect(() => {
    if (!userToken) return
    setLoading(true)
    setError("")
    fetch(`${config.serverUri}/user-insignias/me`, {
      headers: { "x-sc-signature": userToken },
    })
      .then(r => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(data => setInsignias(data.filter(i => i.isEnabled)))
      .catch(() => setError("No se pudieron cargar las insignias"))
      .finally(() => setLoading(false))
  }, [userToken])

  const getCriteriaMessage = badge => {
    const { type, insigniaCriteria: crit } = badge
    switch (type.type) {
      case "total":
        return `Completa un total de ${crit.requiredCount} entrenamientos`
      case "categoria":
        return `Completa ${crit.requiredCount} entrenamientos de la categoría ${crit.category}`
      case "horario": {
        const prefix =
          crit.timeBoundary.type === "morning"
            ? "antes de las"
            : "a partir de las"
        const h = crit.hourLimit
        const period = h < 12 ? "am" : "pm"
        const hour12 = h % 12 === 0 ? 12 : h % 12
        return `Completa ${crit.requiredCount} entrenamientos ${prefix} ${hour12}:00 ${period}`
      }
      case "consecutivos":
        return `Mantén una racha de ${crit.requiredDays} días consecutivos`
      case "desafío":
        return badge.description || "Cumple el desafío especial"
      default:
        return ""
    }
  }

  const shareBadge = badge => {
    const badgeUrl = `${window.location.origin}/insignias/${badge.id}`
    const text = `${badge.name} - ${getCriteriaMessage(badge)}`
    const shareUrl =
      "https://www.facebook.com/sharer/sharer.php" +
      `?u=${encodeURIComponent(badgeUrl)}` +
      `&quote=${encodeURIComponent(text)}`
    window.open(shareUrl, "_blank", "width=600,height=400")
  }

  const handleBadgeClick = badge => {
    setSelectedBadge(badge)
    setShowModal(true)
  }
  const closeModal = () => {
    setShowModal(false)
    setSelectedBadge(null)
  }

  return (
    <>
      {/* No necesitas el SDK aquí */}
      <ContentPageLayout location={location}>
        {/* Banner */}
        <div className="flex flex-col relative" style={{ height: 240 }}>
          <StaticImage
            alt="banner comunidad"
            src="../../images/banner_comunidad.png"
            objectFit="cover"
            style={{ width: "100%", height: "100%" }}
          />
          <div className="absolute inset-x-0 top-24 text-center">
            {formValues.avatar && (
              <img
                src={formValues.avatar}
                alt="Avatar"
                className="w-20 h-20 rounded-full mx-auto mb-2 object-cover"
              />
            )}
            <h3 className="text-white text-xl">{formValues.nombre}</h3>
            <h2 className="text-white">{category}</h2>
          </div>
        </div>

        <CommunityContentLayout
          avatar={formValues.avatar}
          isPremium={isPremium}
        >
          <h2 className="mb-4">Premios e insignias</h2>

          {loading ? (
            <div className="text-center">Cargando insignias...</div>
          ) : error ? (
            <div className="text-center text-red-500">{error}</div>
          ) : (
            <div className="flex flex-wrap justify-center gap-4">
              {insignias.map(badge => (
                <img
                  key={badge.id}
                  src={
                    badge.obtained
                      ? badge.iconActive.url
                      : badge.iconInactive.url
                  }
                  alt={badge.name}
                  className="w-48 h-48 cursor-pointer"
                  onClick={() => handleBadgeClick(badge)}
                />
              ))}
            </div>
          )}

          {showModal && selectedBadge && (
            <div
              onClick={closeModal}
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
              <div
                onClick={e => e.stopPropagation()}
                className="bg-white rounded-lg p-6 max-w-sm w-full text-center"
              >
                <h3 className="text-3xl font-bold mb-4">
                  {selectedBadge.name}
                </h3>
                <img
                  src={
                    selectedBadge.obtained
                      ? selectedBadge.iconActive.url
                      : selectedBadge.iconInactive.url
                  }
                  alt={selectedBadge.name}
                  className="w-32 h-32 mx-auto mb-4"
                />
                {selectedBadge.obtained && (
                  <p className="mb-4 text-sc-primary text-xl">
                    Insignia obtenida el{" "}
                    {new Date(selectedBadge.dateObtained).toLocaleDateString(
                      "es-ES"
                    )}
                  </p>
                )}
                <p className="font-semibold mb-2">¿Cómo obtenerla?</p>
                <p className="mb-4">{getCriteriaMessage(selectedBadge)}</p>
                <p className="font-semibold mb-2">Progreso</p>
                <p className="mb-4">
                  {selectedBadge.type.type === "desafío" ? (
                    <>
                      Has completado {selectedBadge.numericProgress}{" "}
                      {selectedBadge.numericProgress === 1 ? "plan" : "planes"}
                    </>
                  ) : (
                    <>
                      Has completado {selectedBadge.numericProgress} de{" "}
                      {selectedBadge.goal}{" "}
                      {selectedBadge.type.type === "consecutivos"
                        ? selectedBadge.goal === 1
                          ? "día"
                          : "días"
                        : selectedBadge.goal === 1
                        ? "entrenamiento"
                        : "entrenamientos"}
                      {selectedBadge.type.type === "categoria" &&
                        " de esta categoría"}
                    </>
                  )}
                </p>

                {selectedBadge.obtained && (
                  <div className="flex justify-center gap-6 mb-4">
                    <FaFacebook
                      size={32}
                      className="cursor-pointer"
                      onClick={() => shareBadge(selectedBadge)}
                    />
                  </div>
                )}
                <SCButton onClick={closeModal}>Cerrar</SCButton>
              </div>
            </div>
          )}
        </CommunityContentLayout>
      </ContentPageLayout>
    </>
  )
}

export default InsigniasPage
